// extracted by mini-css-extract-plugin
export var audioPlayer = "_kx-0";